<script setup lang="ts">
import type { FormInputEvents, Form, FormSchema, FormErrorWithId } from "@nuxt/ui";

withDefaults(defineProps<{ validateOn?: FormInputEvents[] }>(), {
  validateOn: () => ["blur", "change"],
});

// Permet à un parent de déclencher la validation quand le bouton de submit vit
// hors du <form> (ex : footer de modale orchestrant plusieurs AppForm).
const form = useTemplateRef<Form<FormSchema>>("form");
defineExpose({
  validate: (...args: Parameters<Form<FormSchema>["validate"]>) => form.value?.validate(...args),
  // Permet à handleApiError d'afficher les erreurs de validation serveur (422 Laravel)
  // sous les champs concernés via une ref sur le formulaire.
  setErrors: (...args: Parameters<Form<FormSchema>["setErrors"]>) => form.value?.setErrors(...args),
  // setErrors() n'émet pas `@error` : on amène manuellement le premier champ en erreur
  // dans le viewport, comme le ferait une validation client échouée.
  scrollToFirstError: () => {
    const errors = form.value?.getErrors() as FormErrorWithId[] | undefined;
    if (errors?.length) return scrollToFirstFieldError(errors);
  },
});
</script>

<template>
  <UForm ref="form" :validate-on="validateOn" @error="focusFirstFormError">
    <template #default="slotProps">
      <slot v-bind="slotProps" />
    </template>
  </UForm>
</template>
